import { useMutation } from "@apollo/react-hooks";
import { useAsyncCallback } from 'react-use-async-callback';
import gql from "graphql-tag";
import { AsyncActionStatus } from '../../../shared/abstractStore';
import { QuestionUpdateInput } from '../generated/globalTypes';
import { updateQuestionMutation, updateQuestionMutationVariables } from '../generated/updateQuestionMutation';
import { questionFieldsFragment } from '../models/Question';

/**
 * Get a callback to update a Question in the store.
 */
export function useUpdateQuestionCallback(): [(id: string, model: QuestionUpdateInput) => Promise<void>, AsyncActionStatus] {
    const [mutationAction, { error }] = useMutation<updateQuestionMutation, updateQuestionMutationVariables>(
        gql`
            mutation updateQuestionMutation ($model: QuestionUpdateInput!) {
                updateQuestion(model: $model) {
                    ...questionFields
                }
            }

            ${questionFieldsFragment}
        `
    );

    // Wrap the mutation in a standard callback.
    const [action, { isExecuting, errors: actionErrors }] = useAsyncCallback(async (id: string, model: QuestionUpdateInput) => {
        const result = await mutationAction({ variables: { model: { ...model, id: id } } });
        if (result.errors && result.errors.length) {
            throw result.errors;
        }
    }, [mutationAction]);

    return [action, { isExecuting: isExecuting, errors: error ? error.message : actionErrors }];
}
